var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 60,
    viewBox: "0 0 407 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.095 29.9999C241.095 43.601 228.254 54.6268 212.414 54.6268C196.573 54.6268 183.732 43.601 183.732 29.9999C183.732 16.3989 196.573 5.37305 212.414 5.37305C228.254 5.37305 241.095 16.3989 241.095 29.9999ZM229.622 29.9999C229.622 39.1497 221.918 48.3581 212.414 48.3581C202.909 48.3581 195.205 39.1497 195.205 29.9999C195.205 20.8501 202.909 11.6417 212.414 11.6417C221.918 11.6417 229.622 20.8501 229.622 29.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.43 8.05961H144.902V52.8357H133.43V8.05961Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.272 8.05961H258.745V26.1598L282.131 8.05961H297.575L273.747 26.4178L297.575 52.8357H283.455L265.805 31.791L258.745 37.9782V52.8357H247.272V8.05961Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.105 8.05961V52.8357H345.23V46.5671H312.578V14.3283H344.348V8.05961H301.105Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.755 26.8656H334.64V33.1342H318.755V26.8656Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.055 8.05961H389.355C396.179 8.05961 401.71 13.6728 401.71 20.5969C401.71 27.5211 396.179 33.1342 389.355 33.1342H387.437C395.704 36.0321 403.663 47.8023 406.564 53.0386H392.444C383.622 38.7704 377.275 34.375 372.396 33.1342H366.41V52.8357H354.055V8.05961ZM384.06 26.8656H366.41V14.3283H384.06C387.472 14.3283 390.238 17.1348 390.238 20.5969C390.238 24.059 387.472 26.8656 384.06 26.8656Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.432 35.8208H167.847C174.671 35.8208 180.202 29.6063 180.202 21.9402C180.202 14.2742 174.671 8.05961 167.847 8.05961H148.432V14.9999H161.67C165.081 14.9999 167.847 18.1072 167.847 21.9402C167.847 25.7732 165.081 28.8805 161.67 28.8805H148.432V35.8208Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.286 49.0757C47.8895 49.0757 50 46.9652 50 44.3617V9.07572C45.3977 9.07572 41.6667 12.8067 41.6667 17.4091V34.9091L16.6544 9.89679C16.1287 9.37107 15.4157 9.07572 14.6722 9.07572C12.0918 9.07572 10 11.1675 10 13.7479V49.0757C14.6024 49.0757 18.3334 45.3448 18.3334 40.7424L18.3334 24.0757L41.9527 47.695C42.8367 48.5791 44.0357 49.0757 45.286 49.0757Z",
    fill: "#FF2D18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 0C5.96954 0 0 5.96954 0 13.3333V60H106.667C114.03 60 120 54.0305 120 46.6667V0H13.3333ZM15 3.33333C8.55668 3.33333 3.33333 8.55668 3.33333 15V56.6667H56.6667V3.33333H15ZM104.489 13.3335C104.489 16.9246 101.579 19.8358 97.9877 19.8358H90.8449C82.9338 19.8358 75.3111 21.6667 75.3111 30.8333C75.3111 40.8333 82.4894 43.2266 89.7338 43.2266C92.4449 43.2266 99.5338 43.4934 99.5338 43.4934V35.2381H91.3782C85.0005 35.2381 84.1671 28.3333 84.1671 28.3333H106.667V44.5498C106.667 47.1824 104.627 49.3631 101.999 49.512C98.1115 49.7321 92.6753 50 89.2449 50C76.9782 50 67.5 44.5156 67.5 30.8333C67.5 17.9639 76.1338 13.3333 88.7116 13.3333L104.489 13.3335Z",
    fill: "#FF2D18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.448470d79d15edbb44405b79d10aea11.svg";
export { ForwardRef as ReactComponent };